import { Result } from "../models/interfaces";
import { BaseService } from "./BaseService";

export type AuthResponse = {
  user: AuthUserDto;
  token: AuthToken;
};

export type AuthToken = {
  accessToken: string;
  refreshToken: string;
};
export type IUserAuthenticated = {
  user: AuthUserDto;
  token: AuthToken;
};

export type AuthUserDto = {
  id: number;
  userName: string;
  dateEntered: Date;
  dateEdited: Date;
  enteredBy?: string;
  editedBy?: string;
  uid: string;
  userFullName: string;
  approvingOfficer: boolean;
  email: string;
  phoneNo: string;
  transactionLimit: number;
  isDisabled?: boolean;
  businessId: number;
  userProfileType: number;
  transactionLimitType: number;
  transactionTypes?: string[];
  permissions?: string[];
  businessOwnerId?: number;
  transactionLimitPeriodType: number;
};

export class AuthService extends BaseService {
  async login(
    userName: string,
    password: string
  ): Promise<Result<AuthResponse>> {
    try {
      const url = this.getBaseUrl() + "users/login";

      const resp = await fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName,
          password,
        }),
      });

      if (!resp || resp.status !== 200) {
        return {
          message: "Invalid UserName or Password",
          data: null,
          status: false,
        };
      }

      const respData: Result<AuthResponse> = await resp.json();
      if (!respData) {
        return {
          status: false,
          message: "Invalid UserName and Password",
          data: null,
        };
      }
      return respData;
    } catch (error) {
      console.error(error);
      return {
        message: "An error occured. Please try again",
        status: false,
        data: undefined,
      };
    }
  }

  getCurrentUser(): AuthUserDto | undefined {
    const _currentUser = sessionStorage.getItem("currentUser") as string;
    if (_currentUser === undefined) return undefined;

    return JSON.parse(_currentUser) as AuthUserDto;
  }

  getCurrentUserToken(): AuthToken {
    const _token = JSON.parse(
      sessionStorage.getItem("token") as string
    ) as AuthToken;
    return _token;
  }

  saveUserLoginAuth(user: AuthUserDto, token: AuthToken): void {
    // TODO: create a new cookie that will be sent to the server
    sessionStorage.setItem("currentUser", JSON.stringify(user));
    sessionStorage.setItem("token", JSON.stringify(token));
  }

  async signOutUser() {
    const url = this.getBaseUrl() + "users/signout";
    const response = await fetch(url, {
      method: "post",
    });

    if (response.ok) {
      sessionStorage.removeItem("currentUser");
      sessionStorage.removeItem("token");
    }
  }
}

export default new AuthService();
